/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import {
  TaskDataModel,
  TaskDatumModel,
  TaskDatumType
} from '../../../../../../../../models/task.model';

@Component({
  selector: 'unknown-record',
  templateUrl: './unknown-record.component.html',
  styleUrls: ['./unknown-record.component.scss'],
  standalone: false
})
export class UnknownRecordComponent implements OnInit {
  @Input() record: Map<string, TaskDatumModel> = new Map<string, TaskDatumModel>();
  TaskDatumType = TaskDatumType;

  constructor() {}

  ngOnInit(): void {}
  noSort = () => 0;
}
